




















































import Vue from 'vue'
export default Vue.extend({
    name: "vote-total",
    props: ["name", "pct"],
    data() {
        return {
            w: 0,
        }
    },
    mounted() {
        this.w = (<Element>this.$refs.main).clientWidth;
    },
    computed: {
        fillWidth(): number {
            return this.w * this.pct;
        }
    },
    methods: {
        pick(): void {
            this.$emit("pick");
        }
    }
})
